import { useState, useEffect, createContext, useContext } from 'react';
import { useSelector } from 'react-redux';

import { initialStyles, defaultStyles, useSetCustomTheme } from './useTheme.util';
import { selectCustomerConfigurations } from 'redux/root.selectors';

const SmartScanTheme = createContext<typeof initialStyles | Record<string, string>>(initialStyles);

const useInternalTheme = () => {
  const customerConfigs = useSelector(selectCustomerConfigurations);
  const [styles, setStyles] = useState<typeof initialStyles | Record<string, string>>(initialStyles);
  const setCustomTheme = useSetCustomTheme(setStyles);

  useEffect(() => {
    if (!customerConfigs) return;

    const themes = customerConfigs.themes;
    const hasCustomThemes = themes != null && (themes.default != null || themes.dark != null);

    if (hasCustomThemes) {
      setCustomTheme(themes);
      return;
    }

    setStyles(defaultStyles);
  }, [customerConfigs, setCustomTheme]);

  return { SmartScanTheme, styles };
};

const useTheme = () => {
  const styles = useContext(SmartScanTheme);

  return { styles };
};

export { useTheme, SmartScanTheme, useInternalTheme };
